export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00242.ba18f48f.png";